import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nopassbook',
  templateUrl: './nopassbook.component.html',
  styleUrls: ['./nopassbook.component.css']
})
export class NopassbookComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
